export const multiUserProjectDefault = [
    {
        "value": "IN_CQA",
        "key": "qa_status",
        "operation": "eq"
    },
    {
        "value": "CQA",
        "key": "case_type",
        "operation": "eq"
    }
]


export const multiUserProjectFiltersCoder = [
    ...multiUserProjectDefault,
    {
        "value": "MY_CASES",
        "key": "assignee",
        "operation": "eq"
    },
]

export const singleUserProjectFiltersCoder = [
    {
        "value": "IN_CQA",
        "key": "qa_status",
        "operation": "eq"
    },
    {
        "filters": [
            {
                "key": "assignee",
                "operation": "in",
                "value": "MY_GROUPS"
            },
            {
                "key": "assignee",
                "operation": "in",
                "value": "MY_GROUP_CODERS"
            }
        ],
        "combinator": "OR"
    },
    {
        "value": "CQA",
        "key": "case_type",
        "operation": "eq"
    }
]